import { IContact } from "../types/contacts";
import { IMessage } from "../types/message";
import { apiCore, ApiResponse } from "./apiCore";

import * as url from "./urls";

/**
 * Representa um contato retornado pela API real
 */

/**
 * Filtros opcionais
 */
export interface ContactFilter {
  search?: string;
  regionId?: number;
  active?: boolean;
  [key: string]: any;
}

/**
 * Estrutura usada ao convidar um contato
 */
export interface InviteContactRequest {
  type: string;
  to: string;
  name: string;
  body: string;
  idUser: number;
}

/**
 * 🔹 GET /DootChat/Contacts
 */
export const getContactList = async (
  idEnterprise: number,
): Promise<IContact[]> => {
  // console.log("[contacts.ts] getContactList");
  const response = await apiCore<IContact[]>(
    `${url.GET_CONTACTS}/${idEnterprise}`,
    {
      method: "GET",
      // params: filters,
    },
  );
  return response.data;
};

/**
 * 🔹 POST /DootChat/Invite
 */
export const inviteContact = async (
  data: InviteContactRequest,
): Promise<IMessage> => {
  const response = await apiCore<IMessage>(url.INVITE_CONTACT, {
    method: "POST",
    body: data,
  });

  return response.data;
};
